import {useAuth} from "../hooks/useAuth.ts";
import {Navigate, Outlet, useLocation} from "react-router";
import ErrorBoundary from "./ErrorBoundary";

export default function OnboardedOutlet() {

  const {user} = useAuth();
  const location = useLocation();

  if (!user?.organizationId) {
    return <Navigate to={"/onboarding/create-organization"} replace={true} />
  }

  // Bound each page so a render crash shows a recoverable message inside the
  // app shell instead of white-screening everything. Keying on the path means
  // navigating to another route remounts the boundary and clears the error.
  return (
    <ErrorBoundary key={location.pathname}>
      <Outlet />
    </ErrorBoundary>
  );
}
